// Logo oficial de Mercado Libre (el mismo PNG que usa PlatformLogos) para las filas, modales y
// menús de la integración: reemplaza al ícono genérico de apretón de manos
// (ADR-2026-09-30-refresh-de-productos-en-mis-productos). Es un asset local: no hace falta CachedImg.

import React from "react";

export const MercadoLibreIcon: React.FC<{ className?: string }> = ({
  className = "h-[18px] w-[18px]",
}) => (
  <img
    src="/images/mercado-libre.png"
    alt=""
    aria-hidden="true"
    draggable={false}
    className={`shrink-0 object-contain ${className}`}
  />
);

export default MercadoLibreIcon;
